import { UseFormReturn } from "react-hook-form";
import LoadingSpinnerWithTextComponent from "../../Common/LoadingSpinnerWithText/LoadingSpinnerWithText";
import { CreatePasswordFormSchemaType } from "./CreatePasswordFormSchema";
import PasswordFieldComponent from "../../Common/Input/Password/Password";
import { PrimeButton } from "../../prime/button";

interface CreatePasswordComponentProps {
  isFetching: boolean;
  onSubmit: (data: any) => Promise<void>;
  useFormProps: UseFormReturn<CreatePasswordFormSchemaType>;
}

export const CreatePasswordComponent = (
  props: CreatePasswordComponentProps
) => {
  const { onSubmit, isFetching, useFormProps } = props;

  return (
    <form onSubmit={useFormProps.handleSubmit(onSubmit)}>
      <div className="mb-6">
        <PasswordFieldComponent
          name="password"
          register={useFormProps.register}
          fieldError={useFormProps.formState.errors.password}
          showCheckboxes={true}
          disabled={isFetching}
        />
      </div>

      <PrimeButton
        size="large"
        type="submit"
        status={isFetching ? "loading" : "default"}
      >
        Continue and sign in
      </PrimeButton>
    </form>
  );
};
